import { useTranslation } from 'react-i18next';
import { Text } from '@/components/ui/text';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { BaseModalProps } from '@/contexts/ModalContext';
import { ConfirmationOptions } from '~/global/hooks/useConfirmation';

export interface ConfirmationDialogProps extends BaseModalProps {
  onConfirm: () => void;
  options?: ConfirmationOptions | null;
}

export const ConfirmationDialog = ({
  onConfirm,
  onClose,
  options,
}: ConfirmationDialogProps) => {
  const { t } = useTranslation('common');

  const title = options?.title || t('confirmation.title');
  const description = options?.description || t('confirmation.description');
  const confirmText = options?.confirmText || t('confirmation.confirm');
  const cancelText = options?.cancelText || t('confirmation.cancel');

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <AlertDialog open={true} onOpenChange={(open) => !open && handleCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onPress={handleCancel}>
            <Text>{cancelText}</Text>
          </AlertDialogCancel>
          <AlertDialogAction
            testID="confirmation-confirm-button"
            onPress={handleConfirm}
            className="bg-primary"
          >
            <Text className="text-primary-foreground">{confirmText}</Text>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
